import { render, staticRenderFns } from "./ReportNDVIs.vue?vue&type=template&id=62d145f0&scoped=true"
import script from "./ReportNDVIs.vue?vue&type=script&lang=js"
export * from "./ReportNDVIs.vue?vue&type=script&lang=js"
import style0 from "./ReportNDVIs.vue?vue&type=style&index=0&id=62d145f0&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d145f0",
  null
  
)

export default component.exports